import { Component, OnInit } from '@angular/core';
import { fciWebsiteService } from './../../../service/fci-website.service';
import { Buffer } from 'buffer';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
import Map from 'ol/Map';
import View from 'ol/View';
import { OSM, TileWMS, Vector, Vector as VectorSource } from 'ol/source';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { fromLonLat, toLonLat } from 'ol/proj';
import XYZ from 'ol/source/XYZ';
import { Overlay } from 'ol';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
declare let $: any;
import { CustomServiceService } from './../../../service/custom-service.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
@Component({
  selector: 'app-map-area',
  templateUrl: './map-area.component.html',
  styleUrls: ['./map-area.component.css']
})
export class MapAreaComponent implements OnInit {
  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, public translate: TranslateService) { }
  arrAllZoneData: any = [];
  arrAllRegionData: any = [];
  arrAllDemographicData: any = [];
  arrAllSelectedRegionData: any = [];
  totalNoOfDepots: any = 0;
  riceStock: any = 0;
  wheatStock: any = 0;
  totalCapacity: any = 0;
  totalStock: any = 0;
  date: any;
  link_array = [];

  depo_links: any;
  asOnDate: any = "";
  map: any;
  osmSource: any;
  baseLayer: any;
  baseMap = 'streetMap';
  stateBoundarySource: any;
  stateBoundaryLayer: any;
  zoneBoundarySource: any;
  zoneBoundaryLayer: any;
  regionBoundarySource: any;
  regionBoundaryLayer: any;
  districtBoundarySource: any;
  districtBoundaryLayer: any;
  depoPointSource: any;
  depoPointLayer: any;
  gis_zone_code: any = "";
  gis_region_code: any = "";
  gis_geoserverUrl: any = environment.geoserverUrl;
  overlay: any;
  depotCode: any;
  depotCapacity: any;
  depotName: any;
  zoneName: any;
  regionName: any;
  districtName: any;
  depotRiceStock: any;
  depotWheatStock: any;
  depotTotalStock: any;
  mapCoordinate: any;
  gis_workspace: any = environment.workspace;


  language: any = '';
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  // Function to adjust the zoom level based on screen size
  adjustZoomLevel() {
    if (window.innerWidth < 1099) {
      this.map.getView().setZoom(4);
    } else {
      this.map.getView().setZoom(4.5);
    }

    if (window.innerWidth < 991) {
      this.map.getView().setZoom(4.5);
    }

    if (window.innerWidth < 640) {
      this.map.getView().setZoom(4);
    }

    if (window.innerWidth < 350) {
      this.map.getView().setZoom(3.7);
    }
  }

  ngOnInit(): void {
    // this.getAllData();
    this.language = sessionStorage.getItem('locale');//dynamic

    if (environment.ZONE_ID <= 0 || environment.ZONE_ID == 32) {
      this.getZoneList();
      this.getAllRepoMasterData({ "ZONE_CODE": "", "REGION_CODE": "" });
      // if(environment.ZONE_ID==32 || environment.ZONE_ID < 0){

      // } else {
      //   this.GetAllZoneById(environment.ZONE_ID);
      //   setTimeout(()=>{
      //    this.GetRegion(environment.ZONE_ID);
      //   },1000)
      //    this.getAllRepoMasterData({"ZONE_CODE":environment.ZONE_CODE,"REGION_CODE":0});
      // }
    } else {
      this.GetAllZoneById(environment.ZONE_ID);
      setTimeout(() => {
        this.GetRegion(environment.ZONE_ID);
      }, 1000)
      this.getAllRepoMasterData({ "ZONE_CODE": environment.ZONE_CODE, "REGION_CODE": 0 });
    }

    this.loadClassData();
    const container = <HTMLElement>window.document.getElementById('popup');
    const content = <HTMLElement>window.document.getElementById('popup-content');
    const closer = <HTMLElement>window.document.getElementById('popup-closer');

    this.overlay = new Overlay({
      element: container,
      autoPan: false,
      // autoPanAnimation: {
      //   duration: 250
      // },
      //  positioning: 'center-center',
      //   offset: [0, 10]
    });

    /**
  * Add a click handler to hide the popup.
  * @return {boolean} Don't follow the href.
  */
    var that = this
    closer.onclick = function (): boolean {
      that.overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    window.onclick = function () {
      that.overlay.setPosition(undefined);
      closer.blur();
      // return false;
    };

    this.osmSource = new XYZ({
      url: 'http://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}'
    })



    this.baseLayer = new TileLayer({
      source: this.osmSource,
    })

    this.stateBoundarySource = new TileWMS({
      url: this.gis_geoserverUrl,
      params: { LAYERS: this.gis_workspace + ":india_state_boundary" },
      serverType: "geoserver",
      crossOrigin: "anonymous"
    });
    this.stateBoundaryLayer = new TileLayer({
      source: this.stateBoundarySource
    });

    this.zoneBoundarySource = new TileWMS({
      url: this.gis_geoserverUrl,
      params: { LAYERS: this.gis_workspace + ":zone_master" },
      serverType: "geoserver",
      crossOrigin: "anonymous"
    });
    this.zoneBoundaryLayer = new TileLayer({
      source: this.zoneBoundarySource
    });

    this.regionBoundarySource = new TileWMS({
      url: this.gis_geoserverUrl,
      params: { LAYERS: this.gis_workspace + ":india_state_boundary_v1" },
      serverType: "geoserver",
      crossOrigin: "anonymous"
    });
    this.regionBoundaryLayer = new TileLayer({
      source: this.regionBoundarySource
    });

    this.districtBoundarySource = new TileWMS({
      url: this.gis_geoserverUrl,
      params: { LAYERS: this.gis_workspace + ":merge_state" },
      serverType: "geoserver",
      crossOrigin: "anonymous"
    });
    this.districtBoundaryLayer = new TileLayer({
      source: this.districtBoundarySource
    });

    this.depoPointSource = new TileWMS({
      url: this.gis_geoserverUrl,
      params: { LAYERS: this.gis_workspace + ":depot_master_v1_view" },
      serverType: "geoserver",
      crossOrigin: "anonymous"
    });
    this.depoPointLayer = new TileLayer({
      source: this.depoPointSource
    });

    this.map = new Map({
      layers: [this.baseLayer, this.stateBoundaryLayer, this.zoneBoundaryLayer, this.regionBoundaryLayer, this.districtBoundaryLayer, this.depoPointLayer],
      target: "map",
      overlays: [this.overlay],
      view: new View({
        center: fromLonLat([82.58684962133736, 22.37090331123194]),
        zoom: 4.5
      })
    })

    // FOR MAP SIZE ON WINDOW RESIZE - Call the function initially and add an event listener to update on window resize
    this.adjustZoomLevel.bind(this)(); // Bind this to access the map instance
    window.addEventListener('resize', this.adjustZoomLevel.bind(this)); // Bind this to access the map instance



    this.baseLayer.setVisible(false);
    this.zoneBoundaryLayer.setVisible(false);
    this.regionBoundaryLayer.setVisible(false);
    this.districtBoundaryLayer.setVisible(false);


    this.map.on("singleclick", (evt: any) => {
      const coordinate = evt.coordinate;
      var viewResolution = /** @type {number} */ (evt.map.values_.view.targetResolution_);
      var url = this.depoPointSource.getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        'EPSG:3857',
        { 'INFO_FORMAT': 'application/json' }
      );
      // console.log(url)
      if (url) {
        fetch(url)
          .then((response) => response.text())
          .then((res) => {
            let responseData = JSON.parse(res);
            // console.log(responseData);
            var depotid = responseData.features[0].properties.depot_code;
            this.mapCoordinate = coordinate
            this.getSelectedDepoData({ "DEPO_CODE": depotid })

          })
      }
    })


  }

  loadClassData() {
    let currObj: any = this;


  }
  // getAllData() {
  //   this.fciwebservice.getAllZone().subscribe((resp: any) => {
  //     let respData = resp.RESPONSE_DATA;
  //     let respToken = resp.RESPONSE_TOKEN;
  //     let verifyToken = CryptoJS.HmacSHA256(
  //       respData,
  //       environment.apiHashingKey
  //     ).toString();
  //     if (respToken == verifyToken) {
  //       let response: any = Buffer.from(respData, 'base64');
  //       response = JSON.parse(response.toString());

  //       if (response.status == 200) {
  //           this.arrAllDemographicData = response.result;
  //       }
  //     }
  //   });
  // }


  zone_apirespons: any;
  zoneList: any[] = [];
  getZoneList() {
    this.zoneList = [];
    this.regionList = [];
    this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.data;
            // console.log(this.zoneList);
          }
      }
    });
  }


  GetAllZoneById(zoneid: any) {
    this.zoneList = [];
    this.regionList = [];
    this.httpservice.GetAllZoneById({ 'zone_id': zoneid }).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.list;
            // console.log(res.original.list);
          }
      }
    });
  }

  region_apirespons: any;
  regionList: any[] = [];
  GetRegion(val: any) {
    if (val == "") {
      this.regionList = [];
      this.gis_zone_code = "";
      this.arrAllSelectedRegionData = this.arrAllRegionData;
      this.zoneBoundaryLayer.setVisible(false);
      this.regionBoundaryLayer.setVisible(false);
      this.districtBoundaryLayer.setVisible(false);
      this.stateBoundaryLayer.setVisible(true);
      this.map.getView().animate({
        center: fromLonLat([82.58684962133736, 22.37090331123194]),
        zoom: 4.5,
        duration: 2000
      });
      this.depoPointLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":depot_master_v1_view", 'CQL_FILTER': null });
      this.getAllRepoMasterData({ "ZONE_CODE": "", "REGION_CODE": "" });
      if(this.language=='English'){
        $(".txtCountry").text('India');
      } else {
        $(".txtCountry").text('भारत');
      }
      return;
    } else {
      // console.log(this.zoneList);
      for (let i = 0; i < this.zoneList.length; i++) {
        if (this.zoneList[i].int_Demographic_Id == val) {
          this.gis_zone_code = this.zoneList[i].vch_Code;
          this.getAllRepoMasterData({ "ZONE_CODE": this.zoneList[i].vch_Code, "REGION_CODE": "" });
          this.gotoExtent(this.zoneList[i].vch_Extents);
          if(this.language=='English'){
            $(".txtCountry").text(this.zoneList[i].vch_Demographic_Name);
          } else {
            $(".txtCountry").text(this.zoneList[i].vch_Demographic_Name_Hindi);
          }
        }
      }
      this.zoneBoundaryLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":zone_master", 'CQL_FILTER': "zone_id='" + this.gis_zone_code + "'" });
      this.regionBoundaryLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":india_state_boundary_v1", 'CQL_FILTER': "zone_code='" + this.gis_zone_code + "'" });
      this.depoPointLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":depot_master_v1_view", 'CQL_FILTER': "zone_code='" + this.gis_zone_code + "'" });



      this.stateBoundaryLayer.setVisible(false);
      this.districtBoundaryLayer.setVisible(false);
      this.zoneBoundaryLayer.setVisible(true);
      this.regionBoundaryLayer.setVisible(true);
    }
    this.httpservice.GetRegionByZoneId({ 'zone_id': val }).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData, environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.regionList = res.original.data;
          }
      }
    });
  }



  getAllRegionExtentData(evt: any) {
    if (evt.target.value !== "") {

      for (let i = 0; i < this.regionList.length; i++) {
        if (this.regionList[i].int_Demographic_Id == evt.target.value) {
          this.gis_region_code = this.regionList[i].vch_Code;
          if(this.language=='English'){
            $(".txtCountry").text(this.regionList[i].vch_Demographic_Name);
          } else {
            $(".txtCountry").text(this.regionList[i].vch_Demographic_Name_Hindi);
          }
          this.getAllRepoMasterData({ "ZONE_CODE": this.gis_zone_code, "REGION_CODE": this.regionList[i].vch_Code });
          this.gotoExtent(this.regionList[i].vch_Extents);
        }
      }
      this.regionBoundaryLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":india_state_boundary_v1", 'CQL_FILTER': "reg_code='" + this.gis_region_code + "'" });
      this.depoPointLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":depot_master_v1_view", 'CQL_FILTER': "region_code='" + this.gis_region_code + "'" });
      this.districtBoundaryLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":merge_state", 'CQL_FILTER': "reg_code='" + this.gis_region_code + "'" });
      this.regionBoundaryLayer.setVisible(true);
      this.zoneBoundaryLayer.setVisible(false);
      this.districtBoundaryLayer.setVisible(true);

    } else {
      this.gis_region_code = "";
      for (let i = 0; i < this.zoneList.length; i++) {
        if (this.zoneList[i].vch_Code == this.gis_zone_code) {
          if(this.language=='English'){
            $(".txtCountry").text(this.zoneList[i].vch_Demographic_Name);
          } else {
            $(".txtCountry").text(this.zoneList[i].vch_Demographic_Name_Hindi);
          }
          this.getAllRepoMasterData({ "ZONE_CODE": this.gis_zone_code, "REGION_CODE": "" });
          this.gotoExtent(this.zoneList[i].vch_Extents);
        }
      }
      this.zoneBoundaryLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":zone_master", 'CQL_FILTER': "zone_id='" + this.gis_zone_code + "'" });
      this.regionBoundaryLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":india_state_boundary_v1", 'CQL_FILTER': "zone_code='" + this.gis_zone_code + "'" });
      this.depoPointLayer.getSource().updateParams({ 'LAYERS': this.gis_workspace + ":depot_master_v1_view", 'CQL_FILTER': "zone_code='" + this.gis_zone_code + "'" });
      this.zoneBoundaryLayer.setVisible(true);
      this.regionBoundaryLayer.setVisible(true);
      this.districtBoundaryLayer.setVisible(false);
    }
  }

  gotoExtent(filterObj: any) {
    var bounds = filterObj.split("BOX(")[1].split(")")[0].split(",");
    var b1 = bounds[0].split(" ");
    var b2 = bounds[1].split(" ");
    var my_extent = [parseFloat(b1[0]), parseFloat(b1[1]), parseFloat(b2[0]), parseFloat(b2[1])];
    this.map.getView().fit(my_extent, { duration: 3000 });
  }


  baseMapVisible() {
    if (this.baseMap == 'streetMap') {
      this.baseMap = '';
      this.baseLayer.setVisible(false);
    }
    else {
      this.baseMap = 'streetMap'
      this.baseLayer.setVisible(true);
    }
  }



  getAllRepoMasterData(parms: any) {
    this.fciwebservice.getAllDepotData(parms).subscribe((resp: any) => {
      let respData = resp.RESPONSE_DATA;
      let respToken = resp.RESPONSE_TOKEN;
      let verifyToken = CryptoJS.HmacSHA256(
        respData,
        environment.apiHashingKey
      ).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response.toString());

        if (response.status == 200) {
          let resultData: any = response.result;
          this.totalNoOfDepots = resultData.totalNoOfDepots;
          this.riceStock = Math.round(resultData.riceStock);
          this.wheatStock = Math.round(resultData.wheatStock);
          this.totalCapacity = Math.round(resultData.totalCapacity);
          this.totalStock = Math.round(resultData.totalStock);
          this.asOnDate = resultData.asOnDate;
        }
      }
    })
  }


  getSelectedDepoData(parms1: any) {
    this.fciwebservice.getDepoData(parms1).subscribe((resp: any) => {
      if (resp.body) {
        let respData = resp.body.RESPONSE_DATA;
        let respToken = resp.body.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();

        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response.toString());

          if (response.status == 200) {
            let resultData: any = response.result;
            this.depotCapacity = Math.round(resultData.DEPOT_CAPACITY);
            this.depotCode = resultData.DEPOT_CODE;
            this.depotName = resultData.DEPOT_NAME;
            this.zoneName = resultData.ZONE_NAME;
            this.regionName = resultData.REGION_NAME;
            this.districtName = resultData.DISTRICT_NAME;
            this.depotRiceStock = Math.round(resultData.RICE_STOCK);
            this.depotWheatStock = Math.round(resultData.WHEAT_STOCK);
            this.depotTotalStock = Math.round(resultData.TOTAL_STOCK);
            this.date = resultData.DATE;
            // let convertdDate = this.formatDate(this.date)
            this.link_array = resultData.DEPOT_LINKS;

            // let currObj = this;
            let content = <HTMLElement>(
              window.document.getElementById('popup-content')
            );

            let depocapUnit='MT';
              if(this.language=='English'){
                depocapUnit='MT';
              }else{
                depocapUnit='एमटी';
              }


            if (this.link_array.length > 0) {

              content.innerHTML =

                '<div style= "font-weight:bold;color: #f5931d;">' + this.depotName + ' (' + this.depotCode + ') ' + '<div style= "font-weight:bold;color: #b54711;">' + this.zoneName + '/' + this.regionName + '/' + this.districtName + '</div>' + '</div><table><tr><td>Depot Capacity</td><td class="fw-bold"> : ' +

                this.INRfromar(this.depotCapacity) +

                // ' MT</td></tr><tr><td>Rice Stock</td><td class="fw-bold"> : ' +

                // this.depotRiceStock +

                // ' MT</td></tr><tr><td>Wheat Stock</td><td class="fw-bold"> : ' +

                // this.depotWheatStock +

                // ' MT</td></tr><tr><td>Total Stock</td><td class="fw-bold"> : ' +

                // this.depotTotalStock +

                depocapUnit+`</td></tr>

                  <tr>

                    <td>See Your Depot</td>

                    <td id="createbutton">`



              this.createButtons();

              `</td>

                  </tr>

                </table></div>`;

              setTimeout(() => {

                this.overlay.setPosition(this.mapCoordinate);

              }, 200);

            } else {

              content.innerHTML =

                '<div style= "font-weight:bold;color: #f5931d;">' + this.depotName + ' (' + this.depotCode + ') ' + '<div style= "font-weight:bold;color: #b54711;">' + this.zoneName + '/' + this.regionName + '/' + this.districtName + '</div>' + '</div><table><tr><td>Depot Capacity</td><td class="fw-bold"> : ' +

                this.INRfromar(this.depotCapacity) +

                // ' MT</td></tr><tr><td>Rice Stock</td><td class="fw-bold"> : ' +

                // this.depotRiceStock +

                // ' MT</td></tr><tr><td>Wheat Stock</td><td class="fw-bold"> : ' +

                // this.depotWheatStock +

                // ' MT</td></tr><tr><td>Total Stock</td><td class="fw-bold"> : ' +

                // this.depotTotalStock +

                depocapUnit+'</td></tr><tr><td>See Your Depot</td><td class="fw-bold"> : Not Available</td></tr></table></div>';

              setTimeout(() => {

                this.overlay.setPosition(this.mapCoordinate);

              }, 200);

            }


          } else {
            
          }
        }
      }
    });
  }

  /*
  * Function name: createButtons
  * description : Function To get the array of links in the button format in popup
  * created by  : Roshni Bisoi
  * created on  : 07-08-2023
  */

  createButtons() {
    let ele = <HTMLElement>document.getElementById('createbutton');
    for (var i = 0; i < this.link_array.length; i++) {
      let link = this.link_array[i];
      var btn = document.createElement("BUTTON");
      var t = document.createTextNode("Depot" + (i + 1).toString());
      btn.appendChild(t);
      ele.appendChild(btn);
      btn.setAttribute("class", "buttonGroup");
      var style = document.createElement('style');
      style.innerHTML = '.buttonGroup  { border:0 ; color:blue; background-color: #e5e3e000;}';
      document.head.appendChild(style);

      btn.addEventListener('click', function () {
        Swal.fire({
          title: 'Redirect to Depot Links',
          showDenyButton: true,
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result.isConfirmed) {
            window.open(link, '_blank')
          }
        })

      })
    }
  }



INRfromar(item:any):any{
  if(item==''){
    return 0;
  }

  if(parseFloat(item) <= 0){
    return 0;
  }
  
  return item.toLocaleString('en-IN', {maximumFractionDigits: 0});//,style: 'currency',currency: 'INR'
}







}
